import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditTemplateMenuHeaderComponent } from '../../edit-template-menu-header.component';
import { EditTemplateSpotlightMenuViewModel } from '../edit-template-spotlight-menu-view-model';

@Component({
  selector: 'app-edit-template-spotlight-menu-header',
  templateUrl: './edit-template-spotlight-menu-header.component.html',
  styleUrls: [
    './edit-template-spotlight-menu-header.component.scss',
    '../../../../../shared/styles/edit-page-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateSpotlightMenuHeaderComponent extends EditTemplateMenuHeaderComponent {
  constructor(public override viewModel: EditTemplateSpotlightMenuViewModel) {
    super(viewModel);
  }
}
